// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Corporate Professional Design System */
/* Based on Variation 5 - Professional Corporate */

:root {
  /* Primary Colors */
  --primary-navy: #000042;
  --primary-navy-dark: #000030;
  --primary-navy-light: #000055;

  /* Secondary Colors */
  --secondary-gray: #666666;
  --secondary-gray-dark: #555555;
  --secondary-gray-light: #777777;

  /* Neutral Colors */
  --neutral-white: #ffffff;
  --neutral-light: #f8f9fa;
  --neutral-border: #e9ecef;
  --neutral-text: #333333;

  /* Accent Colors */
  --accent-success: #28a745;
  --accent-warning: #ffc107;
  --accent-danger: #dc3545;
  --accent-info: #17a2b8;

  /* CTA Button Colors - Golden Theme */
  --cta-primary: #FFD700;
  --cta-primary-hover: #FFA500;
  --cta-secondary: #DAA520;
  --cta-secondary-hover: #B8860B;

  /* Typography */
  --font-serif: Georgia, 'Times New Roman', serif;
  --font-sans: Arial, -apple-system, BlinkMacSystemFont, sans-serif;

  /* Spacing */
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 2rem;
  --spacing-xl: 3rem;
  --spacing-xxl: 5rem;

  /* Shadows */
  --shadow-sm: 0 2px 4px rgba(0,0,0,0.08);
  --shadow-md: 0 4px 10px rgba(0,0,0,0.1);
  --shadow-lg: 0 10px 25px rgba(0,0,0,0.15);
  --shadow-xl: 0 20px 40px rgba(0,0,0,0.2);
}

/* Reset and Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-sans);
  line-height: 1.6;
  color: var(--neutral-text);
  background-color: var(--neutral-light);
}

/* Typography */
h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-serif);
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 0.5em;
  color: var(--primary-navy);
}

h1 { font-size: 2.5rem; }
h2 { font-size: 2.2rem; }
h3 { font-size: 1.8rem; }
h4 { font-size: 1.4rem; }
h5 { font-size: 1.2rem; }
h6 { font-size: 1rem; }

p {
  margin-bottom: 1em;
  line-height: 1.7;
}

/* Container */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Buttons - Enhanced for better visibility */
.btn, button {
  display: inline-block;
  padding: 12px 28px;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 600;
  text-align: center;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Primary Button - Navy */
.btn-primary {
  background-color: var(--primary-navy);
  color: white;
  border-color: var(--primary-navy);
}

.btn-primary:hover {
  background-color: var(--primary-navy-light);
  border-color: var(--primary-navy-light);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

/* CTA Buttons - Option 8G: Elegant Golden Wave */
.btn-cta, .btn-demo {
  background:
    radial-gradient(circle at 20% 50%, #FFD700 0%, transparent 50%),
    radial-gradient(circle at 80% 50%, #DAA520 0%, transparent 50%),
    linear-gradient(135deg, #B8860B, #DAA520, #FFD700);
  background-size: 200% 100%, 200% 100%, 100% 100%;
  color: #000042;
  border: 1px solid rgba(184, 134, 11, 0.8);
  padding: 14px 32px;
  font-size: 17px;
  font-weight: 700;
  box-shadow:
    0 0 35px rgba(255, 215, 0, 0.5),
    inset 0 2px 8px rgba(255, 255, 255, 0.3);
  animation:
    elegant-wave 5s ease-in-out infinite,
    wave-glow 2.5s ease-in-out infinite alternate;
  text-shadow: 0 1px 1px rgba(255,255,255,0.3);
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cta:hover, .btn-demo:hover {
  background-size: 300% 100%, 300% 100%, 100% 100%;
  transform: translateY(-3px) scale(1.05);
  box-shadow:
    0 0 50px rgba(255, 215, 0, 0.7),
    inset 0 2px 8px rgba(255, 255, 255, 0.4);
  color: #000042;
}

@keyframes elegant-wave {
  0% { background-position: 0% 50%, 100% 50%, 0% 50%; }
  50% { background-position: 100% 50%, 0% 50%, 0% 50%; }
  100% { background-position: 0% 50%, 100% 50%, 0% 50%; }
}

@keyframes wave-glow {
  0% { box-shadow: 0 0 35px rgba(255, 215, 0, 0.5), inset 0 2px 8px rgba(255, 255, 255, 0.3); }
  100% { box-shadow: 0 0 50px rgba(255, 215, 0, 0.7), inset 0 2px 8px rgba(255, 255, 255, 0.4); }
}

/* Secondary CTA - Option 8G: Elegant Golden Wave */
.btn-cta-secondary {
  background:
    radial-gradient(circle at 20% 50%, #DAA520 0%, transparent 50%),
    radial-gradient(circle at 80% 50%, #B8860B 0%, transparent 50%),
    linear-gradient(135deg, #B8860B, #DAA520, #CD853F);
  background-size: 200% 100%, 200% 100%, 100% 100%;
  color: #000042;
  border: 1px solid rgba(184, 134, 11, 0.8);
  padding: 14px 32px;
  font-size: 17px;
  font-weight: 700;
  box-shadow:
    0 0 30px rgba(218, 165, 32, 0.5),
    inset 0 2px 8px rgba(255, 255, 255, 0.3);
  animation:
    elegant-wave 5s ease-in-out infinite,
    wave-glow-secondary 2.5s ease-in-out infinite alternate;
  text-shadow: 0 1px 1px rgba(255,255,255,0.3);
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cta-secondary:hover {
  background-size: 300% 100%, 300% 100%, 100% 100%;
  transform: translateY(-3px) scale(1.05);
  box-shadow:
    0 0 45px rgba(218, 165, 32, 0.7),
    inset 0 2px 8px rgba(255, 255, 255, 0.4);
  color: #000042;
}

@keyframes wave-glow-secondary {
  0% { box-shadow: 0 0 30px rgba(218, 165, 32, 0.5), inset 0 2px 8px rgba(255, 255, 255, 0.3); }
  100% { box-shadow: 0 0 45px rgba(218, 165, 32, 0.7), inset 0 2px 8px rgba(255, 255, 255, 0.4); }
}

/* Secondary Button */
.btn-secondary {
  background-color: var(--secondary-gray);
  color: white;
  border-color: var(--secondary-gray);
}

.btn-secondary:hover {
  background-color: var(--secondary-gray-dark);
  border-color: var(--secondary-gray-dark);
  transform: translateY(-1px);
}

/* Outline Button */
.btn-outline {
  background-color: transparent;
  color: var(--primary-navy);
  border-color: var(--primary-navy);
}

.btn-outline:hover {
  background-color: var(--primary-navy);
  color: white;
}

/* Cards */
.card {
  background-color: white;
  border-radius: 8px;
  padding: var(--spacing-lg);
  border: 1px solid var(--neutral-border);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-5px);
  border-color: var(--primary-navy);
}

/* Forms */
.form-group {
  margin-bottom: var(--spacing-md);
}

.form-label {
  display: block;
  margin-bottom: var(--spacing-xs);
  font-weight: 600;
  color: var(--neutral-text);
}

.form-control {
  width: 100%;
  padding: 12px;
  border: 2px solid var(--neutral-border);
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.3s ease;
  background-color: white;
}

.form-control:focus {
  outline: none;
  border-color: var(--primary-navy);
  box-shadow: 0 0 0 3px rgba(0, 51, 102, 0.1);
}

/* Tables */
.table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  box-shadow: var(--shadow-sm);
}

.table th {
  background-color: var(--primary-navy);
  color: white;
  padding: var(--spacing-md);
  text-align: left;
  font-weight: 600;
}

.table td {
  padding: var(--spacing-md);
  border-bottom: 1px solid var(--neutral-border);
}

.table tr:hover {
  background-color: var(--neutral-light);
}

/* Badges */
.badge {
  display: inline-block;
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 600;
}

.badge-primary {
  background-color: var(--primary-navy);
  color: white;
}

.badge-success {
  background-color: var(--accent-success);
  color: white;
}

.badge-warning {
  background-color: var(--accent-warning);
  color: var(--neutral-text);
}

.badge-danger {
  background-color: var(--accent-danger);
  color: white;
}

/* Navigation */
.navbar {
  background-color: white;
  box-shadow: var(--shadow-md);
  padding: var(--spacing-md) 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.navbar-brand {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-navy);
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  gap: var(--spacing-lg);
  align-items: center;
  list-style: none;
}

.navbar-link {
  color: var(--neutral-text);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.navbar-link:hover {
  color: var(--primary-navy);
}

/* Section Headers */
.section-header {
  text-align: center;
  margin-bottom: var(--spacing-xl);
}

.section-title {
  color: var(--primary-navy);
  margin-bottom: var(--spacing-md);
}

.section-subtitle {
  color: var(--secondary-gray);
  font-size: 1.2rem;
  max-width: 600px;
  margin: 0 auto;
}

/* Trust Badges */
.trust-badge {
  background-color: var(--neutral-light);
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: 25px;
  border: 2px solid var(--neutral-border);
  font-weight: 600;
  color: var(--secondary-gray);
  font-size: 0.9rem;
  display: inline-block;
}

/* Footer */
.footer {
  background-color: var(--primary-navy);
  color: white;
  padding: var(--spacing-xl) 0 var(--spacing-lg);
}

.footer a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer a:hover {
  color: white;
}

/* Responsive Grid */
.grid {
  display: grid;
  gap: var(--spacing-lg);
}

.grid-cols-1 { grid-template-columns: 1fr; }
.grid-cols-2 { grid-template-columns: repeat(2, 1fr); }
.grid-cols-3 { grid-template-columns: repeat(3, 1fr); }
.grid-cols-4 { grid-template-columns: repeat(4, 1fr); }

/* Utility Classes */
.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }

.mt-1 { margin-top: var(--spacing-sm); }
.mt-2 { margin-top: var(--spacing-md); }
.mt-3 { margin-top: var(--spacing-lg); }
.mt-4 { margin-top: var(--spacing-xl); }

.mb-1 { margin-bottom: var(--spacing-sm); }
.mb-2 { margin-bottom: var(--spacing-md); }
.mb-3 { margin-bottom: var(--spacing-lg); }
.mb-4 { margin-bottom: var(--spacing-xl); }

.p-1 { padding: var(--spacing-sm); }
.p-2 { padding: var(--spacing-md); }
.p-3 { padding: var(--spacing-lg); }
.p-4 { padding: var(--spacing-xl); }

/* Loading States */
.loading {
  opacity: 0.7;
  pointer-events: none;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid var(--neutral-border);
  border-top-color: var(--primary-navy);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .grid-cols-2,
  .grid-cols-3,
  .grid-cols-4 {
    grid-template-columns: 1fr;
  }

  .navbar-nav {
    flex-direction: column;
    gap: var(--spacing-md);
  }

  h1 { font-size: 2rem; }
  h2 { font-size: 1.8rem; }
  h3 { font-size: 1.5rem; }

  .btn-cta, .btn-demo {
    width: 100%;
    padding: 16px;
  }
}

/* Admin Dashboard Specific */
.admin-header {
  background: linear-gradient(135deg, var(--primary-navy), var(--primary-navy-light));
  color: white;
  padding: var(--spacing-lg) 0;
}

.dashboard-card {
  background: white;
  border-radius: 8px;
  padding: var(--spacing-lg);
  box-shadow: var(--shadow-md);
  margin-bottom: var(--spacing-lg);
}

.stat-card {
  background: linear-gradient(135deg, var(--primary-navy), var(--primary-navy-light));
  color: white;
  padding: var(--spacing-lg);
  border-radius: 8px;
  text-align: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: bold;
  font-family: var(--font-serif);
}

.stat-label {
  opacity: 0.9;
  margin-top: var(--spacing-xs);
}

/* Lithuanian Text Fixes */
.lithuanian-heading {
  font-family: var(--font-serif);
  color: var(--primary-navy);
  letter-spacing: -0.5px;
}

.lithuanian-text {
  line-height: 1.7;
  color: var(--neutral-text);
}

/* Highlight Demo Button */
.demo-highlight {
  position: relative;
  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    box-shadow: 0 0 10px var(--cta-primary), 0 0 20px var(--cta-primary), 0 0 30px var(--cta-primary);
  }
  to {
    box-shadow: 0 0 20px var(--cta-primary), 0 0 30px var(--cta-primary), 0 0 40px var(--cta-primary);
  }
}

/* Fix for weird Lithuanian text */
.clean-lithuanian {
  font-family: var(--font-sans);
  font-weight: normal;
  letter-spacing: normal;
}

/* Loading spinner animation */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/styles/corporate-design.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC,kDAAkD;;AAElD;EACE,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;;EAE7B,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;;EAE/B,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;;EAEvB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;;EAEtB,qCAAqC;EACrC,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;;EAE9B,eAAe;EACf,+CAA+C;EAC/C,iEAAiE;;EAEjE,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,YAAY;EACZ,uCAAuC;EACvC,uCAAuC;EACvC,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,KAAK,iBAAiB,EAAE;AACxB,KAAK,iBAAiB,EAAE;AACxB,KAAK,iBAAiB,EAAE;AACxB,KAAK,iBAAiB,EAAE;AACxB,KAAK,iBAAiB,EAAE;AACxB,KAAK,eAAe,EAAE;;AAEtB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,qCAAqC;EACrC,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,iDAAiD;AACjD;EACE;;;sDAGoD;EACpD,gDAAgD;EAChD,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;;4CAE0C;EAC1C;;iDAE+C;EAC/C,4CAA4C;EAC5C,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,uCAAuC;EACvC;;4CAE0C;EAC1C,cAAc;AAChB;;AAEA;EACE,KAAK,6CAA6C,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,OAAO,6CAA6C,EAAE;AACxD;;AAEA;EACE,KAAK,qFAAqF,EAAE;EAC5F,OAAO,qFAAqF,EAAE;AAChG;;AAEA,mDAAmD;AACnD;EACE;;;sDAGoD;EACpD,gDAAgD;EAChD,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;;4CAE0C;EAC1C;;2DAEyD;EACzD,4CAA4C;EAC5C,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,uCAAuC;EACvC;;4CAE0C;EAC1C,cAAc;AAChB;;AAEA;EACE,KAAK,sFAAsF,EAAE;EAC7F,OAAO,sFAAsF,EAAE;AACjG;;AAEA,qBAAqB;AACrB;EACE,uCAAuC;EACvC,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA,UAAU;AACV;EACE,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,uCAAuC;EACvC,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,UAAU;AACV;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;AACxC;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA,eAAe;AACf;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,sCAAsC;EACtC,4CAA4C;EAC5C,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,qCAAqC;EACrC,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,eAAe,0BAA0B,EAAE;AAC3C,eAAe,qCAAqC,EAAE;AACtD,eAAe,qCAAqC,EAAE;AACtD,eAAe,qCAAqC,EAAE;;AAEtD,oBAAoB;AACpB,eAAe,kBAAkB,EAAE;AACnC,aAAa,gBAAgB,EAAE;AAC/B,cAAc,iBAAiB,EAAE;;AAEjC,QAAQ,6BAA6B,EAAE;AACvC,QAAQ,6BAA6B,EAAE;AACvC,QAAQ,6BAA6B,EAAE;AACvC,QAAQ,6BAA6B,EAAE;;AAEvC,QAAQ,gCAAgC,EAAE;AAC1C,QAAQ,gCAAgC,EAAE;AAC1C,QAAQ,gCAAgC,EAAE;AAC1C,QAAQ,gCAAgC,EAAE;;AAE1C,OAAO,0BAA0B,EAAE;AACnC,OAAO,0BAA0B,EAAE;AACnC,OAAO,0BAA0B,EAAE;AACnC,OAAO,0BAA0B,EAAE;;AAEnC,mBAAmB;AACnB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,sBAAsB;AACtB;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA,KAAK,eAAe,EAAE;EACtB,KAAK,iBAAiB,EAAE;EACxB,KAAK,iBAAiB,EAAE;;EAExB;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA,6BAA6B;AAC7B;EACE,mFAAmF;EACnF,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,mFAAmF;EACnF,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE;IACE,iGAAiG;EACnG;EACA;IACE,iGAAiG;EACnG;AACF;;AAEA,kCAAkC;AAClC;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":["/* Corporate Professional Design System */\n/* Based on Variation 5 - Professional Corporate */\n\n:root {\n  /* Primary Colors */\n  --primary-navy: #000042;\n  --primary-navy-dark: #000030;\n  --primary-navy-light: #000055;\n\n  /* Secondary Colors */\n  --secondary-gray: #666666;\n  --secondary-gray-dark: #555555;\n  --secondary-gray-light: #777777;\n\n  /* Neutral Colors */\n  --neutral-white: #ffffff;\n  --neutral-light: #f8f9fa;\n  --neutral-border: #e9ecef;\n  --neutral-text: #333333;\n\n  /* Accent Colors */\n  --accent-success: #28a745;\n  --accent-warning: #ffc107;\n  --accent-danger: #dc3545;\n  --accent-info: #17a2b8;\n\n  /* CTA Button Colors - Golden Theme */\n  --cta-primary: #FFD700;\n  --cta-primary-hover: #FFA500;\n  --cta-secondary: #DAA520;\n  --cta-secondary-hover: #B8860B;\n\n  /* Typography */\n  --font-serif: Georgia, 'Times New Roman', serif;\n  --font-sans: Arial, -apple-system, BlinkMacSystemFont, sans-serif;\n\n  /* Spacing */\n  --spacing-xs: 0.25rem;\n  --spacing-sm: 0.5rem;\n  --spacing-md: 1rem;\n  --spacing-lg: 2rem;\n  --spacing-xl: 3rem;\n  --spacing-xxl: 5rem;\n\n  /* Shadows */\n  --shadow-sm: 0 2px 4px rgba(0,0,0,0.08);\n  --shadow-md: 0 4px 10px rgba(0,0,0,0.1);\n  --shadow-lg: 0 10px 25px rgba(0,0,0,0.15);\n  --shadow-xl: 0 20px 40px rgba(0,0,0,0.2);\n}\n\n/* Reset and Base Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-sans);\n  line-height: 1.6;\n  color: var(--neutral-text);\n  background-color: var(--neutral-light);\n}\n\n/* Typography */\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-serif);\n  font-weight: 700;\n  line-height: 1.3;\n  margin-bottom: 0.5em;\n  color: var(--primary-navy);\n}\n\nh1 { font-size: 2.5rem; }\nh2 { font-size: 2.2rem; }\nh3 { font-size: 1.8rem; }\nh4 { font-size: 1.4rem; }\nh5 { font-size: 1.2rem; }\nh6 { font-size: 1rem; }\n\np {\n  margin-bottom: 1em;\n  line-height: 1.7;\n}\n\n/* Container */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* Buttons - Enhanced for better visibility */\n.btn, button {\n  display: inline-block;\n  padding: 12px 28px;\n  border-radius: 4px;\n  text-decoration: none;\n  font-weight: 600;\n  text-align: center;\n  border: 2px solid transparent;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 16px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Primary Button - Navy */\n.btn-primary {\n  background-color: var(--primary-navy);\n  color: white;\n  border-color: var(--primary-navy);\n}\n\n.btn-primary:hover {\n  background-color: var(--primary-navy-light);\n  border-color: var(--primary-navy-light);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n/* CTA Buttons - Option 8G: Elegant Golden Wave */\n.btn-cta, .btn-demo {\n  background:\n    radial-gradient(circle at 20% 50%, #FFD700 0%, transparent 50%),\n    radial-gradient(circle at 80% 50%, #DAA520 0%, transparent 50%),\n    linear-gradient(135deg, #B8860B, #DAA520, #FFD700);\n  background-size: 200% 100%, 200% 100%, 100% 100%;\n  color: #000042;\n  border: 1px solid rgba(184, 134, 11, 0.8);\n  padding: 14px 32px;\n  font-size: 17px;\n  font-weight: 700;\n  box-shadow:\n    0 0 35px rgba(255, 215, 0, 0.5),\n    inset 0 2px 8px rgba(255, 255, 255, 0.3);\n  animation:\n    elegant-wave 5s ease-in-out infinite,\n    wave-glow 2.5s ease-in-out infinite alternate;\n  text-shadow: 0 1px 1px rgba(255,255,255,0.3);\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-cta:hover, .btn-demo:hover {\n  background-size: 300% 100%, 300% 100%, 100% 100%;\n  transform: translateY(-3px) scale(1.05);\n  box-shadow:\n    0 0 50px rgba(255, 215, 0, 0.7),\n    inset 0 2px 8px rgba(255, 255, 255, 0.4);\n  color: #000042;\n}\n\n@keyframes elegant-wave {\n  0% { background-position: 0% 50%, 100% 50%, 0% 50%; }\n  50% { background-position: 100% 50%, 0% 50%, 0% 50%; }\n  100% { background-position: 0% 50%, 100% 50%, 0% 50%; }\n}\n\n@keyframes wave-glow {\n  0% { box-shadow: 0 0 35px rgba(255, 215, 0, 0.5), inset 0 2px 8px rgba(255, 255, 255, 0.3); }\n  100% { box-shadow: 0 0 50px rgba(255, 215, 0, 0.7), inset 0 2px 8px rgba(255, 255, 255, 0.4); }\n}\n\n/* Secondary CTA - Option 8G: Elegant Golden Wave */\n.btn-cta-secondary {\n  background:\n    radial-gradient(circle at 20% 50%, #DAA520 0%, transparent 50%),\n    radial-gradient(circle at 80% 50%, #B8860B 0%, transparent 50%),\n    linear-gradient(135deg, #B8860B, #DAA520, #CD853F);\n  background-size: 200% 100%, 200% 100%, 100% 100%;\n  color: #000042;\n  border: 1px solid rgba(184, 134, 11, 0.8);\n  padding: 14px 32px;\n  font-size: 17px;\n  font-weight: 700;\n  box-shadow:\n    0 0 30px rgba(218, 165, 32, 0.5),\n    inset 0 2px 8px rgba(255, 255, 255, 0.3);\n  animation:\n    elegant-wave 5s ease-in-out infinite,\n    wave-glow-secondary 2.5s ease-in-out infinite alternate;\n  text-shadow: 0 1px 1px rgba(255,255,255,0.3);\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-cta-secondary:hover {\n  background-size: 300% 100%, 300% 100%, 100% 100%;\n  transform: translateY(-3px) scale(1.05);\n  box-shadow:\n    0 0 45px rgba(218, 165, 32, 0.7),\n    inset 0 2px 8px rgba(255, 255, 255, 0.4);\n  color: #000042;\n}\n\n@keyframes wave-glow-secondary {\n  0% { box-shadow: 0 0 30px rgba(218, 165, 32, 0.5), inset 0 2px 8px rgba(255, 255, 255, 0.3); }\n  100% { box-shadow: 0 0 45px rgba(218, 165, 32, 0.7), inset 0 2px 8px rgba(255, 255, 255, 0.4); }\n}\n\n/* Secondary Button */\n.btn-secondary {\n  background-color: var(--secondary-gray);\n  color: white;\n  border-color: var(--secondary-gray);\n}\n\n.btn-secondary:hover {\n  background-color: var(--secondary-gray-dark);\n  border-color: var(--secondary-gray-dark);\n  transform: translateY(-1px);\n}\n\n/* Outline Button */\n.btn-outline {\n  background-color: transparent;\n  color: var(--primary-navy);\n  border-color: var(--primary-navy);\n}\n\n.btn-outline:hover {\n  background-color: var(--primary-navy);\n  color: white;\n}\n\n/* Cards */\n.card {\n  background-color: white;\n  border-radius: 8px;\n  padding: var(--spacing-lg);\n  border: 1px solid var(--neutral-border);\n  box-shadow: var(--shadow-sm);\n  transition: all 0.3s ease;\n}\n\n.card:hover {\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-5px);\n  border-color: var(--primary-navy);\n}\n\n/* Forms */\n.form-group {\n  margin-bottom: var(--spacing-md);\n}\n\n.form-label {\n  display: block;\n  margin-bottom: var(--spacing-xs);\n  font-weight: 600;\n  color: var(--neutral-text);\n}\n\n.form-control {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid var(--neutral-border);\n  border-radius: 4px;\n  font-size: 16px;\n  transition: border-color 0.3s ease;\n  background-color: white;\n}\n\n.form-control:focus {\n  outline: none;\n  border-color: var(--primary-navy);\n  box-shadow: 0 0 0 3px rgba(0, 51, 102, 0.1);\n}\n\n/* Tables */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.table th {\n  background-color: var(--primary-navy);\n  color: white;\n  padding: var(--spacing-md);\n  text-align: left;\n  font-weight: 600;\n}\n\n.table td {\n  padding: var(--spacing-md);\n  border-bottom: 1px solid var(--neutral-border);\n}\n\n.table tr:hover {\n  background-color: var(--neutral-light);\n}\n\n/* Badges */\n.badge {\n  display: inline-block;\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: 4px;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.badge-primary {\n  background-color: var(--primary-navy);\n  color: white;\n}\n\n.badge-success {\n  background-color: var(--accent-success);\n  color: white;\n}\n\n.badge-warning {\n  background-color: var(--accent-warning);\n  color: var(--neutral-text);\n}\n\n.badge-danger {\n  background-color: var(--accent-danger);\n  color: white;\n}\n\n/* Navigation */\n.navbar {\n  background-color: white;\n  box-shadow: var(--shadow-md);\n  padding: var(--spacing-md) 0;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.navbar-brand {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--primary-navy);\n  text-decoration: none;\n}\n\n.navbar-nav {\n  display: flex;\n  gap: var(--spacing-lg);\n  align-items: center;\n  list-style: none;\n}\n\n.navbar-link {\n  color: var(--neutral-text);\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.navbar-link:hover {\n  color: var(--primary-navy);\n}\n\n/* Section Headers */\n.section-header {\n  text-align: center;\n  margin-bottom: var(--spacing-xl);\n}\n\n.section-title {\n  color: var(--primary-navy);\n  margin-bottom: var(--spacing-md);\n}\n\n.section-subtitle {\n  color: var(--secondary-gray);\n  font-size: 1.2rem;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n/* Trust Badges */\n.trust-badge {\n  background-color: var(--neutral-light);\n  padding: var(--spacing-sm) var(--spacing-md);\n  border-radius: 25px;\n  border: 2px solid var(--neutral-border);\n  font-weight: 600;\n  color: var(--secondary-gray);\n  font-size: 0.9rem;\n  display: inline-block;\n}\n\n/* Footer */\n.footer {\n  background-color: var(--primary-navy);\n  color: white;\n  padding: var(--spacing-xl) 0 var(--spacing-lg);\n}\n\n.footer a {\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer a:hover {\n  color: white;\n}\n\n/* Responsive Grid */\n.grid {\n  display: grid;\n  gap: var(--spacing-lg);\n}\n\n.grid-cols-1 { grid-template-columns: 1fr; }\n.grid-cols-2 { grid-template-columns: repeat(2, 1fr); }\n.grid-cols-3 { grid-template-columns: repeat(3, 1fr); }\n.grid-cols-4 { grid-template-columns: repeat(4, 1fr); }\n\n/* Utility Classes */\n.text-center { text-align: center; }\n.text-left { text-align: left; }\n.text-right { text-align: right; }\n\n.mt-1 { margin-top: var(--spacing-sm); }\n.mt-2 { margin-top: var(--spacing-md); }\n.mt-3 { margin-top: var(--spacing-lg); }\n.mt-4 { margin-top: var(--spacing-xl); }\n\n.mb-1 { margin-bottom: var(--spacing-sm); }\n.mb-2 { margin-bottom: var(--spacing-md); }\n.mb-3 { margin-bottom: var(--spacing-lg); }\n.mb-4 { margin-bottom: var(--spacing-xl); }\n\n.p-1 { padding: var(--spacing-sm); }\n.p-2 { padding: var(--spacing-md); }\n.p-3 { padding: var(--spacing-lg); }\n.p-4 { padding: var(--spacing-xl); }\n\n/* Loading States */\n.loading {\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.spinner {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 3px solid var(--neutral-border);\n  border-top-color: var(--primary-navy);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .grid-cols-2,\n  .grid-cols-3,\n  .grid-cols-4 {\n    grid-template-columns: 1fr;\n  }\n\n  .navbar-nav {\n    flex-direction: column;\n    gap: var(--spacing-md);\n  }\n\n  h1 { font-size: 2rem; }\n  h2 { font-size: 1.8rem; }\n  h3 { font-size: 1.5rem; }\n\n  .btn-cta, .btn-demo {\n    width: 100%;\n    padding: 16px;\n  }\n}\n\n/* Admin Dashboard Specific */\n.admin-header {\n  background: linear-gradient(135deg, var(--primary-navy), var(--primary-navy-light));\n  color: white;\n  padding: var(--spacing-lg) 0;\n}\n\n.dashboard-card {\n  background: white;\n  border-radius: 8px;\n  padding: var(--spacing-lg);\n  box-shadow: var(--shadow-md);\n  margin-bottom: var(--spacing-lg);\n}\n\n.stat-card {\n  background: linear-gradient(135deg, var(--primary-navy), var(--primary-navy-light));\n  color: white;\n  padding: var(--spacing-lg);\n  border-radius: 8px;\n  text-align: center;\n}\n\n.stat-number {\n  font-size: 2.5rem;\n  font-weight: bold;\n  font-family: var(--font-serif);\n}\n\n.stat-label {\n  opacity: 0.9;\n  margin-top: var(--spacing-xs);\n}\n\n/* Lithuanian Text Fixes */\n.lithuanian-heading {\n  font-family: var(--font-serif);\n  color: var(--primary-navy);\n  letter-spacing: -0.5px;\n}\n\n.lithuanian-text {\n  line-height: 1.7;\n  color: var(--neutral-text);\n}\n\n/* Highlight Demo Button */\n.demo-highlight {\n  position: relative;\n  animation: glow 2s ease-in-out infinite alternate;\n}\n\n@keyframes glow {\n  from {\n    box-shadow: 0 0 10px var(--cta-primary), 0 0 20px var(--cta-primary), 0 0 30px var(--cta-primary);\n  }\n  to {\n    box-shadow: 0 0 20px var(--cta-primary), 0 0 30px var(--cta-primary), 0 0 40px var(--cta-primary);\n  }\n}\n\n/* Fix for weird Lithuanian text */\n.clean-lithuanian {\n  font-family: var(--font-sans);\n  font-weight: normal;\n  letter-spacing: normal;\n}\n\n/* Loading spinner animation */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
